import React from "react";
import { FileText, DollarSign, Clock, GitBranch } from "lucide-react";
import { Card, CardContent } from "../ui/card";

const formatCurrency = (value) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value || 0);

export function StatsCards({ analytics }) {
  const stats = [
    { label: "Total Contracts", value: analytics?.total_contracts || 0, icon: FileText, iconBg: "bg-slate-100 dark:bg-slate-800", iconColor: "text-slate-600 dark:text-slate-300", testId: "stat-total-contracts" },
    { label: "Total Value", value: formatCurrency(analytics?.total_contract_value), icon: DollarSign, iconBg: "bg-emerald-100 dark:bg-emerald-900/30", iconColor: "text-emerald-600 dark:text-emerald-400", testId: "stat-contract-value" },
    { label: "Expiring Soon", value: analytics?.expiring_soon || 0, sub: "Next 30 days", icon: Clock, iconBg: "bg-amber-100 dark:bg-amber-900/30", iconColor: "text-amber-600 dark:text-amber-400", testId: "stat-expiring-soon" },
    { label: "Pending Approvals", value: analytics?.pending_approvals || 0, icon: GitBranch, iconBg: "bg-blue-100 dark:bg-blue-900/30", iconColor: "text-blue-600 dark:text-blue-400", testId: "stat-pending-approvals" },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((s) => (
        <Card key={s.testId} className="stat-card hover:shadow-md transition-shadow" data-testid={s.testId}>
          <CardContent className="pt-6">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-xs font-mono uppercase tracking-wider text-slate-500">{s.label}</p>
                <p className="text-3xl font-semibold mt-2 text-slate-900 dark:text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  {s.value}
                </p>
                {s.sub && <p className="text-xs text-slate-500 mt-1">{s.sub}</p>}
              </div>
              <div className={`w-10 h-10 rounded-sm ${s.iconBg} flex items-center justify-center`}>
                <s.icon size={20} className={s.iconColor} />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
